import { render, staticRenderFns } from "./OutgoingComment.vue?vue&type=template&id=a7f7905c&scoped=true&"
import script from "./OutgoingComment.vue?vue&type=script&lang=ts&"
export * from "./OutgoingComment.vue?vue&type=script&lang=ts&"
import style0 from "./OutgoingComment.vue?vue&type=style&index=0&id=a7f7905c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f7905c",
  null
  
)

export default component.exports